import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "truncate",
    standalone: false,
})
export class TruncatePipe implements PipeTransform {
    transform(value: string, limit = 10): string {
        return value?.length > limit ? value.substring(0, limit) + "..." : value;
    }
}
